export default "__VITE_ASSET__BKhERFFg__"